export default "__VITE_ASSET__B__i117V__"